import React from 'react';
import { useTranslation } from 'react-i18next';
import "./LocalAttraction.css"
import Card from "./card/Card";

const LocalAttraction = ({ localAttractions, onEdit, onDelete }) => {
  const { t } = useTranslation('attraction');

  return (
    <div
      style={
        (!localAttractions || localAttractions.length === 0)
          ? { maxHeight: "80px" }
          : {}
      }
      className={"localAttraction"}
    >
      <h3>
        {t('heading')}
      </h3>
      <div className={"local-Attractions"}>
        {(!localAttractions || localAttractions.length === 0) && (
          <p>{t('noData')}</p>
        )}
        {localAttractions && localAttractions.map((attraction, index) => (
          <Card
            attraction={attraction}
            title={attraction.name}
            desc={attraction.description}
            link={attraction.url}
            image={attraction.image}
            onEdit={onEdit}
            onDelete={onDelete}
            key={attraction.id ?? index}
          />
        ))}
      </div>
    </div>
  );
};

export default LocalAttraction;
